import './glowingtext.css'

export const GlowingText1em = ({ content }) => (
    <div className='glowingtext1em'>
        <p>
            <span>{content}</span>
        </p>
    </div>
);
